var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 94,
    viewBox: "0 0 197 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.291 15.1261C105.638 9.4278 111.682 9.40002 111.682 9.40002C111.682 9.40002 112.581 14.7574 108.262 19.9182C103.651 25.4289 98.4094 24.5272 98.4094 24.5272C98.4094 24.5272 97.4251 20.1932 101.291 15.1261ZM98.9623 28.28C101.199 28.28 105.35 25.2226 110.753 25.2226C120.053 25.2226 123.711 31.8037 123.711 31.8037C123.711 31.8037 116.556 35.4421 116.556 44.2704C116.556 54.2294 125.47 57.6616 125.47 57.6616C125.47 57.6616 119.239 75.1034 110.822 75.1034C106.956 75.1034 103.951 72.5127 99.8775 72.5127C95.7267 72.5127 91.6076 75.2 88.9247 75.2C81.239 75.2002 71.5293 58.6549 71.5293 45.3552C71.5293 32.2702 79.7479 25.406 87.4567 25.406C92.4681 25.406 96.357 28.28 98.9623 28.28Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.f6a665234aa2f973122c6e009cce7893.svg";
export { ForwardRef as ReactComponent };